<div
  class="w-full md:h-full flex flex-col justify-center"
  *ngIf="status === 'info'"
>
  <img
    src="../../assets/svg/cfa-sante.svg"
    alt="Info"
    class="mx-auto p-4 h-16 md:h-32"
  />
  <div
    class="text-grey text-md text-center mx-auto w-auto max-w-2xl md:w-11/12 px-4 py-12"
  >
    {{ message }}
  </div>
  <div class="md:flex md:justify-center">
    <div
      (click)="close()"
      class="text-center text-sm bg-yellow py-3 px-6 mx-6 md:mx-2 my-6 text-white rounded-lg cursor-pointer md:w-1/3"
    >
      Non
    </div>
    <div
      (click)="confirm()"
      class="text-center text-sm py-3 px-6 mx-6 md:mx-2 my-6 cursor-pointer md:w-1/3 rounded-lg text-white bg-yellow"
    >
      Oui
    </div>
  </div>
</div>
